import { AxiosInstance, AxiosResponse } from "axios";
import i18next from "i18next";

type TokenHandlerResponse =
  | {
    status: 'tokenReturned';
    token: string;
    isSubscriptionPurchased: false;
    errorMessage?: undefined;
  }
  | {
    status: 'success';
    token?: undefined;
    isSubscriptionPurchased: true;
    errorMessage?: undefined;
  }
  | {
    status: 'error';
    token?: undefined;
    isSubscriptionPurchased: false;
    errorMessage: {
      title: string;
      status: number;
      detail: string;
      Exception: string;
    };
  };

export class TestOneTimePaymentService {
  constructor(private readonly axiosInstance: AxiosInstance) { }

  async purchaseSubscriptionWithAddon(
    email: string,
    planCode: string,
    currency: string,
    couponCode: string
  ): Promise<TokenHandlerResponse> {
    const response = await this.axiosInstance.post(`/api/PaymentAdmin/purchase-subscription-with-addon`, {
      Email: email,
      PlanCode: planCode,
      Currency: currency,
      CouponCode: couponCode,
    });

    if (response.data) {
      if (response.status === 406) {
        //if 406 is returned it means that 3D secure handling is required and we need to save params
        return {
          status: 'tokenReturned',
          token: response.data,
          isSubscriptionPurchased: false,
        }; //threeDSecureActionTokenId is needed to start 3D Secure challenge
      } else if (!response.data.isError && response.data.data === true) {
        return { status: 'success', isSubscriptionPurchased: true };
      } else {
        return {
          status: 'error',
          isSubscriptionPurchased: false,
          errorMessage: response.data.detail,
        };
      }
    }

    throw Error(i18next.t('3DSecureTokenError', { ns: 'organizationPage' }));
  }

  async tokenHandler(
    tokenId: string,
    email: string,
    planCode: string,
    currency: string,
    couponCode?: string
  ): Promise<TokenHandlerResponse> {
    const response = await this.axiosInstance.post(`/api/PaymentAdmin`, {
      TokenId: tokenId,
      Email: email,
      PlanCode: planCode,
      Currency: currency,
      CouponCode: couponCode,
    });

    if (response.data) {
      if (response.status === 406) {
        //if 406 is returned it means that 3D secure handling is required and we need to save params
        return {
          status: 'tokenReturned',
          token: response.data,
          isSubscriptionPurchased: false,
        }; //threeDSecureActionTokenId is needed to start 3D Secure challenge
      } else if (!response.data.isError && response.data.data === true) {
        return { status: 'success', isSubscriptionPurchased: true };
      } else {
        return {
          status: 'error',
          isSubscriptionPurchased: false,
          errorMessage: response.data.detail,
        };
      }
    }

    throw Error(i18next.t('3DSecureTokenError', { ns: 'organizationPage' }));
  }

  async sendThreeDSecureRequest(
    tokenId: string,
    email: string,
    planCode: string,
    currency: string,
    couponCode: string,
    threeDSecureTokenId: string
  ): Promise<AxiosResponse<any, any>> {
    const response = await this.axiosInstance.post(`/api/PaymentAdmin`, {
      TokenId: tokenId,
      Email: email,
      PlanCode: planCode,
      Currency: currency,
      CouponCode: couponCode,
      ThreeDSecureToken: threeDSecureTokenId,
    });

    if (response.data) return response;

    throw Error(i18next.t('3DSecureRequestError', { ns: 'organizationPage' }));
  }
}